import {
	get,
	post
} from './http.js'; //导入axios实例文件中方法
// let bsae_api = process.env.BASE_API ? './'+process.env.BASE_API :'..' //获取项目api请求地址
//根据id获取用户信息
// export const getUserInfoById = (id) => {
// 	return get(`${bsae_api}/web/user/${id}`); //resfulapi风格
// }
// 注册获取短信验证码
export const getcodes = (data) => {
	return post('/V1/Common​/Message​/SendPhoneCode', data);
}
// 手机注册提交
export const phoneregister = (data) => {
	return post('/V1/Member/Account/Register', data)
}
//手机号登录
export const phonelogin = (data) => {
	return post('/V1/Member/Account/Login', data)
}

//获取微信扫码登录二维码
export const getLoginQrCode=(data)=>{
	return get('/V1/Common/Weixin/LoginQrCode',data)
}

//获取微信扫码结果
export const postScanLogin=(data)=>{
	return post('/V1/Member/Account/ScanLogin',data)
}

// 忘记密码发送验证码
export const findgetcodes = (data) => {
	return post('/Member/V1/Password/VerificationCode', data)
}
// 邮箱忘记密码发送验证码
export const findgetemailcodes = (data) => {
	return post('/V1/Common​/Message​/SendPhoneCode', data)
}
//手机提交忘记密码
export const changepassword = (data) => {
	return post('/V1/Member/Account/FindPassword', data)
}

//是否支付成功
export const PayResult = (data) => {
	return post('/V1/Pay/PayResult', data)
}
//课程提示
export const getHelps = (data) => {
	return get('/v1/Course/Help/Query', data)
}



// 个人中心
export const getuser = (data) => {
	return get('/V1/Member/Member/Info', data)
}
// 修改个人信息
export const changeuser = (data) => {
	return post('/V1/Member/Member/Edit', data)
}
// 修改个人中心密码
export const userchangepassword = (data) => {
	return post('/V1/Member/Account/EditPassword', data)
}

// 阿里云点播
export const getVideo = (data) => {
	return get('/V1/Common/AliyunVod/VideoPlayAuth', data)
}

// 首页 分类
export const getIndexs = (data) => {
	return get('/V1/Website​/Home​/View', data)
}

// 方舟资讯 分类
export const newsCategory = (data) => {
	return get('/V1/Content/News/Category', data)
}


// 方舟资讯列表
export const newsList = (data) => {
	return get('/V1/Content/News/QueryPage', data)
}
// 首页 星辰资讯
export const HomeArticle = (data) => {
	return get('/V1/Content/News/HomeArticle', data)
}
// 资讯详情
export const newsDetail = (data) => {
	return get('/V1/Content/News/Detail', data)
}
// 资讯详情收藏
export const Collection = (data) => {
	return post('/V1/Content/News/Collection', data)
}

// 资讯查看
export const NewsSee = (data) => {
	return get('/V1/Content/News/ViewQueryPage', data)
}
// 资讯收藏列表
export const NewsCollection = (data) => {
	return get('/V1/Content/News/CollectionQueryPage', data)
}
// 热门资讯列表
export const NewsHotArticle = (data) => {
	return get('/V1/Content/News/HotArticle', data)
}
//获取活动分类
export const PracticeKinds=()=>{
	return get('/V1/Activity/Activity/Category')
}

//获取我参与的活动
export const myParticipationActivity=(data)=>{
	return get('V1/Activity/Activity/ApplyList',data)
}

// 活动沙龙列表
export const Activitys = (data) => {
	return get('/V1/Activity/Activity/QueryPage', data)
}
//活动沙龙详情
export const ActivityDetail = (data) => {
	return get('/V1/Activity/Activity/Detail', data)
}

// 申请报名
export const sign = (data) => {
	return post('/V1/Activity/Activity/Apply', data)
}

// 课程分类
export const CategoryClassification = (data) => {
	return get('/v1/Course/Category/Query', data)
}
// 课程列表
export const CategoryList = (data) => {
	return get('/v1/Course/Course/QueryPage', data)
}
//课程详情
export const ClassDetail = (data) => {
	return get('/v1/Course/Course/Detail', data)
}

//课程查看记录
export const ClassSee = (data) => {
	return get('/v1/Course/ViewLog/QueryPage', data)
}
//课程购买记录
export const ClassBuy = (data) => {
	return get('/v1/Course/Order/QueryPage', data)
}
//获取订单
export const orderAdd = (data) => {
	return post('/v1/Course/Order/Add', data)
}

//发起订单
export const orderPay = (data) => {
	return post('/V1/Pay/Add', data)
}

//联系我们
export const getcontact = (data) => {
	return get('/Member/V1/Setting/Contact', data)
}
// 意见反馈
export const feedback = (data) => {
	return post('/V1/Member/Feedback/Add', data)
}
//阿里oss上传
export const aliupload = (data) => {
	return get('/V1/Common/AliyunOSS/Sign', data)
}

// 退出登录
export const quitlogin = (data) => {
	return post('/V1/Member/Account/LoginOut', data)
}

// 底部页面数据
export const getOther = (data) => {
	return get('/V1/Website/Page/Detail', data)
}

//获取讲师信息
export const getLecturer = (data) => {
	return get('/v1/Course/Lecturer/Query', data)
}

export const demand = (data) => {
	return post('/v1/Demand/Add', data)
}

//解决方案资料相关接口
//获取资料分类
export const getType = (data) => {
	return get('/V1/Content/Document/Category', data)
}
//获取资料列表
export const getDatumList = (data) => {
	return get('/V1/Content/Document/QueryPage', data)
}
//查看资料详细
export const getDatumDetail = (data) => {
	return get('/V1/Content/Document/Detail', data)
}
//查看二维码
export const getQrcode = (data) => {
	return get('/V1/Content/Document/GetWeixinQrCode', data)
}
//资料收藏或取消
export const postDatumCollection = (data) => {
	return post('/V1/Content/Document/Collection', data)
}
//获取资料收藏列表
export const getDatumCollectionList=(data)=>{
	return get('/V1/Content/Document/CollectionQueryPage',data)
}

//考试相关接口
//获取题目
export const gettitle = (data) => {
	return get('/v1/Course/Exam/TestPaper', data)
}
//提交答案
export const subexam = (data) => {
	return post('/v1/Course/Exam/Submit', data,{'content-type': 'application/problem+json; charset=utf-8'},false)
}
//获取结果
export const lookexam = (data) => {
	return get('/v1/Course/Exam/Result', data)
}
//获取我的考试列表
export const getMyexam = (data) => {
	return get('/v1/Course/Exam/QueryByMy', data)
}

//获取我提交的需求
export const getMytDatumList = (data) =>{
	return get('/V1/Demand/QueryPage',data)
}

//获取我的证书列表
export const getMycertificate = (data) => {
	return get('/v1/Course/Certificate/List', data)
}

//获取调研分类
export const getSurveyCategory = (data) => {
	return get('/V1/Survey/Category', data)
}

//获取调研列表
export const getSurveyQuery = (data) => {
	return get('/V1/Survey/Query', data)
}

//获取调研详情
export const getSurveyDetail = (data) => {
	return get('/V1/Survey/Detail', data)
}

//获取我的调研
export const getSurveyMyList = (data) => {
	return get('/V1/Survey/MyList', data)
}

//获取调研答案
export const getSurveyAnswer = (data) => {
	return get('/V1/Survey/Answer', data)
}

//提交调研答案
export const postSurvey = (data) => {
	return post('/V1/Survey/Submit', data)
}

//获取绑定微信二维码
export const getBindWeiXin = (data) => {
	return get('/V1/Member/Account/Weixin/BindQrcode', data)
}

//用户绑定微信
export const postBindPhone = (data)=>{
	return post('/V1/Member/Account/BindPhone',data)
}

//专家专栏
export const getExpertList = (data)=>{//专家列表
	return get('/V1/Content/Experts/QueryPage',data)
}
export const getspecialDetail = (data)=>{//专家详情
	return get('/V1/Content/Experts/Detail',data)
}
export const getExpertNews = (data)=>{//专栏列表 （传id为0），专栏详情（传id）
	return get('/V1/Content/ExpertsNews/QueryPage',data)
}
export const postExpertFocusOn = (data)=>{//关注
	return post('/V1/Content/Experts/FocusOn',data)
}



// // 监控用户在线情况
// export const jkuser = (data) => {
// 	return post('/V1/Member/Online/Heartbeat', data)
// }

